<template>
  <form @submit.prevent="emitSave" id="acordMappingTableAddEditDialog">
    <h4 class="mb-4">{{ "ADD" | translate }}</h4>

    <div class="form-group" id="acordMappingTableAddEditDialog-formGroup-Maatschappij">
      <label>{{ "Maatschappij" | translate }}<span class="asterisk">*</span></label>
      <select
        class="form-control form-control-sm"
        v-model="acordMapping.insurerName"
        id="acordMappingTableAddEditDialog-formGroup-Maatschappij-select"
      >
        <option value="" :id="'acordMappingTableAddEditDialog-select-option-Maatschappij-'+ ' '"></option>
        <template v-for="insurer in insurers">
          <option :key="insurer.name" :value="insurer.name" :id="'acordMappingTableAddEditDialog-select-option-'+insurer.name">
            {{insurer.name}} - {{insurer.description}}
          </option>
        </template>
      </select>
    </div>

    <div class="form-group" id="acordMappingTableAddEditDialog-formGroup-Branche">
      <label>{{ "Branche" | translate }}<span class="asterisk">*</span></label>
      <select
        class="form-control form-control-sm"
        v-model="acordMapping.productLineName"
        id="acordMappingTableAddEditDialog-formGroup-Branche-select"
      >
        <option value="" :id="'acordMappingTableAddEditDialog-select-option-branche-'+ ' '"></option>
        <template v-for="productline in productlines">
          <option :key="productline.name" :value="productline.name" :id="'productTableAddEditDialog-select-option-'+productline.name">
            {{productline.name}} - {{productline.description}}
          </option>
        </template>
      </select>
    </div>

    <div class="form-group" id="acordMappingTableAddEditDialog-formGroup-Productnaam">
      <label
        >{{ "Productnaam" | translate }} <span class="asterisk">*</span></label
      >
      <select
        class="form-control form-control-sm"
        v-model="acordMapping.productName"
        id="acordMappingTableAddEditDialog-formGroup-Branche-select"
      >
        <option value="" :id="'acordMappingTableAddEditDialog-select-option-branche-'+ ' '"></option>
        <template v-for="product in products">
          <option :key="product.name" :value="product.name" :id="'productTableAddEditDialog-select-option-'+product.name">
            {{product.name}} - {{product.description}}
          </option>
        </template>
      </select>
    </div>

    <div class="form-group" id="acordMappingTableAddEditDialog-formGroup-Omschrijving">
      <label>{{ "extCoverageTypeCd" | translate }} <span class="asterisk">*</span></label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="acordMapping.extCoverageTypeCd"
        required
        id="acordMappingTableAddEditDialog-formGroup-Omschrijving-input"
      />
    </div>   

    <div class="form-group" id="acordMappingTableAddEditDialog-formGroup-ProductId">
      <label>{{ "Premium field" | translate }} <span class="asterisk">*</span></label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="acordMapping.premiumField"
        required
        id="acordMappingTableAddEditDialog-formGroup-ProductId-input"
      />
    </div>

    <div class="mt-4 text-right" id="acordMappingTableAddEditDialog-formGroup-buttons">
      <button class="btn btn-link" type="button" @click="emitClose"
      id="acordMappingTableAddEditDialog-closeButton">
        {{ "CLOSE" | translate }}
      </button>

      <button class="btn btn-primary" type="submit" :disabled="!isFormValid"
      id="acordMappingTableAddEditDialog-addButton">
        {{ "ADD" | translate }}
      </button>
    </div>
  </form>
</template>

<script>

export default {
  props: ['edited', 'productlines', 'insurers', 'products'],
  data() {
    return {
      acordMapping: {}
    };
  },
  computed: {
    isFormValid() {
      return this.acordMapping.productName;
    }
  },
  methods: {
    emitSave() {
      this.$emit(this.edited ? 'update' : 'save', this.acordMapping);
      this.acordMapping = {};
    },
    emitClose() {
      this.$emit('close');
      this.acordMapping = {};
    }
  },
  watch: {
    edited(newVal, oldVal) {
      this.acordMapping = {...newVal};
    }
  }
};
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

>>> .vdp-datepicker__calendar {
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/acord-mapping/AcordMappingAddEditDialog.vue